import React from 'react'
import styled from 'styled-components'
import PointSvg from '/static/images/ic-point-light-blue.svg'

const PointBalance = ({
  points,
  isFetchingProfile,
  isLoggedIn,
  hasBindPhone,
  paymentIntegration,
}) =>
  isLoggedIn &&
  hasBindPhone &&
  !isFetchingProfile && (
    <BalanceLabelWrapper>
      <PointLabel>我的積分:</PointLabel>
      {paymentIntegration && <PointSvg />}
      <PointValue>{points}</PointValue>
    </BalanceLabelWrapper>
  )

export const PointValue = styled.div`
  margin-left: 4px;
  color: ${(p) => p.theme.color.primary};
  font-weight: 500;
  font-size: 20px;
`

export const BalanceLabelWrapper = styled.div`
  font-size: 16px;
  display: flex;
  line-height: 1;
  width: 100%;
  align-items: center;
  color: ${(p) => p.theme.color.dark200};
`

const PointLabel = styled.span`
  padding-right: 2px;
`

export default PointBalance
